<template>
  <div class="footer">
    © <span id="year"></span> Node.Zone - Transform &amp; Unify - by ComfortPages
  </div>
</template>
<script>
const yearEl = document.getElementById("year");
if (yearEl) yearEl.textContent = new Date().getFullYear();
</script>